
//const baseUrl = "https://localhost:7058/api"; 
//const baseUrl = "https://apps.genus.in/clmsapiTest/api";
//const baseUrl = "https://uatapps.genus.in/clmsapi/api";
const baseUrl = "https://apps.genus.in/clmsapi/api";
export const API_ENDPOINTS ={

getLogin: () => `${baseUrl}/Login/login`,
setPasswordReset: () => `${baseUrl}/Login/PasswordReset`,
getDropDownListAll: (category) => 
`${baseUrl}/ApprovalProcess/GetDropDownList/${category}`,
getMenuAll: (userID) => 
    `${baseUrl}/ApprovalProcess/GetMenuList/${userID}`,
getMarqueeMsg: () => 
    `${baseUrl}/MenuProcess/GetMarqueeMsg`,
getEmployeeData: (userID) => 
    `${baseUrl}/EmployeeProcess/GetEmployeeData/${userID}`,
getCLMSEmployeeData: (userID) => 
    `${baseUrl}/EmployeeProcess/GetCLMSEmployeeData/${userID}`,
setEmployeeData: () => 
    `${baseUrl}/EmployeeProcess/InsertEmployee`,
setEmployeeValue: () => 
    `${baseUrl}/EmployeeProcess/SetEmployeeValue`,
setEmpQualification: () => 
    `${baseUrl}/EmployeeProcess/SetEmpQualification`,
setAttendance: () => 
    `${baseUrl}/EmployeeProcess/AttendanceUpload`,
setEmployeeUpload: () => 
    `${baseUrl}/EmployeeProcess/UploadEmployee`,
setPunchUpload: () => 
    `${baseUrl}/EmployeeProcess/UploadEmployeeAttendance`,
setInActiveUpload: () => 
    `${baseUrl}/EmployeeProcess/UploadEmployeeInActive`,
kentAttendanceSync: (fromDate, toDate) =>
    `${baseUrl}/KentSync/KentAttendanceSync?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}`,
setHoliday: () => 
    `${baseUrl}/EmployeeProcess/HolidayUpload`,
getBaseUrl: () => `${baseUrl}`,

getMenusAll: (userID) => 
    `${baseUrl}/MenuProcess/GetMenuList/${userID}`,
setMenuRights: () => 
    `${baseUrl}/MenuProcess/UpdateUserRights`,
getPlantsAll: (userID) => 
    `${baseUrl}/MenuProcess/GetPlantList/${userID}`,
getDepartmentAll: (userID,plantID) => 
    `${baseUrl}/MenuProcess/GetDepartmentList/${userID},${plantID}`,
setPlantRights: () => 
    `${baseUrl}/MenuProcess/UpdatePlantRights`,
setDepartmentRights: () => 
    `${baseUrl}/MenuProcess/UpdateDepartmentRights`,
getCompanyAll: (userID) => 
    `${baseUrl}/MenuProcess/GetComanyList/${userID}`,
setCompanyRights: () => 
    `${baseUrl}/MenuProcess/UpdateComanyRights`,
getVendorAll: (userID) => 
    `${baseUrl}/MenuProcess/GetVendorList/${userID}`,
setVendorRights: () => 
    `${baseUrl}/MenuProcess/UpdateVendorRights`,
getDepartment: (EmpCode,PlantID) => 
    `${baseUrl}/EmployeeProcess/GetDepartment/${EmpCode},${PlantID}`,
getSubDepartment: (DeptID) => 
    `${baseUrl}/EmployeeProcess/GetSubDepartment/${DeptID}`,
getDesignation: () => 
    `${baseUrl}/EmployeeProcess/GetDesignation`,
getGrade: () => 
    `${baseUrl}/EmployeeProcess/GetGrade`,
getLocation: () => 
    `${baseUrl}/EmployeeProcess/GetLocation`,
getQualification: () => 
    `${baseUrl}/EmployeeProcess/GetQualification`,
getBank: () => 
    `${baseUrl}/EmployeeProcess/GetBank`,
// getExecuteProcedure: (EmployeeCode) => 
//     `${baseUrl}/EmployeeProcess/ExecutProcedure/${EmployeeCode}`,
getExecuteProcedure: () =>
`${baseUrl}/EmployeeProcess/ExecutProcedure`,

getWeekOff: () => 
    `${baseUrl}/EmployeeProcess/GetWeekOff`,
getPlant: (EmpCode) => 
    `${baseUrl}/EmployeeProcess/GetPlant/${EmpCode}`,
getShiftMaster: (PlantID) => 
    `${baseUrl}/EmployeeProcess/getShiftMaster/${PlantID}`,
getCompany: (mode) => 
    `${baseUrl}/EmployeeProcess/GetCompany/${mode}`,
getShift: (PlantID) => 
    `${baseUrl}/EmployeeProcess/GetShift/${PlantID}`,
getVender: (mode) => 
    `${baseUrl}/EmployeeProcess/GetVender/${mode}`,
getBlood: () => 
    `${baseUrl}/EmployeeProcess/GetBlood`,
getEmployeeStatus: () => 
    `${baseUrl}/EmployeeProcess/GetEmployeeStatus`,
getEmployeeChart: () => 
    `${baseUrl}/EmployeeProcess/GetEmployeeChart`,
getEmpolyeeCode: (PlantID) => 
    `${baseUrl}/EmployeeProcess/GetEmpolyeeCode/${PlantID}`,

getAttendancePivotReport: () => 
    `${baseUrl}/EmployeeProcess/GetPivotAttendanceReport`,

getMonthlyOTReport: () => 
    `${baseUrl}/EmployeeProcess/GetPivotOTReport`,
getPivotInOutReport: () => 
    `${baseUrl}/EmployeeProcess/GetPivotInOutReport`,

getEmployeePunch: (UserCode,Month) => 
    `${baseUrl}/EmployeeProcess/GetEmployeePunch/${UserCode},${Month}`,
getAttendancePunch: () => 
    `${baseUrl}/EmployeeProcess/GetAttendancePunch`,
getHolidayCalendar: (PlantID,Year) => 
    `${baseUrl}/EmployeeProcess/GetHolidayCalendar/${PlantID},${Year}`,
SetEmployeePunch: () => 
    `${baseUrl}/EmployeeProcess/SetEmployeePunch`,
getTPLogin: () => 
    `${baseUrl}/MenuProcess/GetTPLogin`,
getAttendanceUser: () => 
    `${baseUrl}/MenuProcess/GetAttendanceUser`,
setTPLogin: () => 
    `${baseUrl}/MenuProcess/SetTPLogin`,
setAttendanceRight: () => 
    `${baseUrl}/MenuProcess/SetAttendanceRight`,
getEmployeeReport: () => 
    `${baseUrl}/EmployeeProcess/GetEmployeeReport`,
getEmployeeProfile: (UserCode) => 
    `${baseUrl}/EmployeeProcess/GetEmployeeProfile/${UserCode}`,
getDailyPunch: () => 
    `${baseUrl}/EmployeeProcess/GetDailyPunch`,
getEmployeeSearch: (EmpSearch) => 
    `${baseUrl}/EmployeeProcess/GetEmployeeSearch/${EmpSearch}`,
getEmployeeShift: () => 
    `${baseUrl}/EmployeeProcess/GetEmployeeShift`,
setEmployeeShift: () => 
    `${baseUrl}/EmployeeProcess/SetEmployeeShift`,

getEmployeeWeekOff: () => 
    `${baseUrl}/EmployeeProcess/GetEmployeeWeekOff`,
getWeekOffOverride: () => 
    `${baseUrl}/EmployeeProcess/GetWeekOffOverride`,
setEmployeeWeekOff: () => 
    `${baseUrl}/EmployeeProcess/SetEmployeeWeekOff`,
saveWeekOffOverride: () => 
    `${baseUrl}/EmployeeProcess/saveWeekOffOverride`,
updateTPLogin: () => 
    `${baseUrl}/MenuProcess/UpdateTPLogin`,
updateAttendanceRight: () => 
    `${baseUrl}/MenuProcess/UpdateAttendanceRight`,

getTemplate: (fileName) => 
    `${baseUrl}/EmployeeProcess/DownloadTemplate/${fileName}`,

InsertApprover: () => `${baseUrl}/ApprovalProcess/InsertApproval`,

getAttendanceChart: (PlantID,Mode,ShiftID) => 
    `${baseUrl}/EmployeeProcess/GetAttendanceChart/${PlantID},${Mode},${ShiftID}`,
getGetMastData: (Type) => 
    `${baseUrl}/EmployeeProcess/GetMastData/${Type}`,
getGetMasterTable: () => 
    `${baseUrl}/EmployeeProcess/GetMasterTable`,
getEmployeeSalaryReport: () => 
    `${baseUrl}/EmployeeProcess/GetSalaryReport`,
getAttendanceMonthlyPDF: () => 
    `${baseUrl}/EmployeeProcess/GetAttendancePivotAllPdf`,
getEmployeeListReport: () => 
    `${baseUrl}/EmployeeProcess/GetEmployeeListReport`,
getPayRollGenerator: () => 
    `${baseUrl}/EmployeeProcess/GetPayRollGenerator`,
setLockPayroll: () => 
    `${baseUrl}/EmployeeProcess/LockPayroll`,
getEmployeeDOLReport: () => 
    `${baseUrl}/EmployeeProcess/GetEmployeeDOLReport`,
getHREmail: () => 
    `${baseUrl}/MenuProcess/GetHREmail`,
setHREmail: () => 
    `${baseUrl}/MenuProcess/SetHREmail`,

getPlan: (PlantID,MonthYear) => 
    `${baseUrl}/EmployeeProcess/GetPlan/${PlantID},${MonthYear}`,
getPlanReport: (PlantID,MonthYear) => 
    `${baseUrl}/EmployeeProcess/GetPlanReport/${PlantID},${MonthYear}`,
setPlan: () => 
    `${baseUrl}/EmployeeProcess/SetPlan`,
setShiftMaster: () => 
    `${baseUrl}/EmployeeProcess/SetShiftMaster`,
getEmployeeDashBoard: () => 
    `${baseUrl}/LeaveProcess/GetEmployeeDashBoard`,
getEmployeeCalender: () => 
    `${baseUrl}/LeaveProcess/GetEmployeeCalender`,
setEmployeeLeave: () => 
    `${baseUrl}/LeaveProcess/SetEmployeeLeave`,
getEmployeeLeaveStatus: () => 
    `${baseUrl}/LeaveProcess/GetEmployeeLeaveStatus`,
setLeaveMaster: () => 
    `${baseUrl}/LeaveProcess/SetLeaveMaster`,

getEmployeeList: () => 
    `${baseUrl}/LeaveProcess/GetEmployeeList`,
getEmployeeAttendanceDetails: () => 
    `${baseUrl}/LeaveProcess/GetEmployeeAttendanceDetails`,
getEmployeeShiftDetails: () => 
    `${baseUrl}/LeaveProcess/GetEmployeeShiftDetails`,
getLeaveList: () => 
    `${baseUrl}/LeaveProcess/GetLeaveList`,
setLeaveAR: () => 
    `${baseUrl}/LeaveProcess/SetLeaveAR`,
setLeaveUpload: () => 
    `${baseUrl}/LeaveProcess/UploadLeave`,
setLeaveBalanceUpload: () => 
    `${baseUrl}/LeaveProcess/UploadLeaveBalance`,
getFloorWise: (PlantID) => 
    `${baseUrl}/EmployeeProcess/GetFloorWise/${PlantID}`,
getLineWise: (FloorID, PlantID) => 
    `${baseUrl}/EmployeeProcess/GetLineWise/${FloorID}`,
getEmployeeLeaveList: () => 
    `${baseUrl}/LeaveProcess/GetEmployeeLeaveList`,
setEmployeeLeaveList: () => 
    `${baseUrl}/LeaveProcess/SetEmployeeLeaveList`,

getDepartmentWisePunch: () => 
    `${baseUrl}/EmployeeProcess/GetDepartmentWisePunch`,

getEmployeeFloor: () => 
    `${baseUrl}/EmployeeProcess/GetEmployeeFloor`,
setEmployeeFloor: () => 
    `${baseUrl}/EmployeeProcess/SetEmployeeFloor`,
getEmployeePassword: () => 
    `${baseUrl}/EmployeeProcess/GetEmployeePassword`,
}